import { Form, Input, Select, Space, Switch } from 'antd'
import React from 'react'

const { Option } = Select

const SouscripteurForm = ({ formData, setFormData, professions }) => {
  // ---------- TELEPHONE (HTML natif + style AntD) ----------
  const sanitizePhone = (v = '') => v.replace(/\D/g, '').slice(0, 8)

  const formatPhoneDisplay = (value = '') => {
    const digits = sanitizePhone(value)
    return digits.replace(/(\d{2})(?=\d)/g, '$1 ').trim()
  }

  const phoneRegex = /^(22|90|91|92|93|96|98|99|70|71|79|97)\d{6}$/

  const handlePhoneChange = (e) => {
    const raw = e.target.value
    const caret = e.target.selectionStart ?? raw.length

    // nombre de chiffres avant le curseur dans la valeur brute
    const digitsBefore = raw.slice(0, caret).replace(/\D/g, '').length

    const digits = sanitizePhone(raw)
    const formatted = formatPhoneDisplay(digits)

    // écrit directement dans l'input HTML
    e.target.value = formatted

    // stocke la version sans espaces
    setFormData((prev) => ({ ...prev, contact: [digits] }))

    // repositionne le curseur correctement
    requestAnimationFrame(() => {
      const newPos = digitsBefore + Math.floor(Math.max(0, digitsBefore - 1) / 2)
      e.target.setSelectionRange(newPos, newPos)
    })
  }

  const isPhoneInvalid =
    !!formData?.contact?.[0] && !phoneRegex.test(sanitizePhone(formData.contact[0]))

  return (
    <div>
      <div className="mb-4">
        <Space size="large">
          <div>
            <label className="me-2">Type de personne:</label>
            <Switch
              checkedChildren="Personne morale"
              unCheckedChildren="Personne physique"
              checked={formData.typePersonne === 'MORALE'}
              defaultValue={formData?.typePersonne === 'MORALE' || false}
              onChange={(checked) =>
                setFormData((prev) => ({
                  ...prev,
                  typePersonne: checked ? 'MORALE' : 'PHYSIQUE',
                }))
              }
            />
          </div>
        </Space>
      </div>

      <div className="row">
        <div className="col-md-6">
          <Form.Item
            label={formData.typePersonne === 'PHYSIQUE' ? 'Nom' : 'Dénomination sociale'}
            name="nom"
            rules={[{ required: true, message: 'Veuillez entrer le nom du souscripteur' }]}
          >
            <Input
              value={formData.nom}
              defaultValue={formData?.nom}
              onChange={(e) => setFormData((prev) => ({ ...prev, nom: e.target.value }))}
              placeholder={formData.typePersonne === 'PHYSIQUE' ? 'Nom' : 'Dénomination sociale'}
            />
          </Form.Item>
        </div>

        {formData.typePersonne === 'PHYSIQUE' && (
          <div className="col-md-6">
            <Form.Item
              label="Prénom(s)"
              name="prenom"
              rules={[{ required: true, message: 'Veuillez entrer le(s) prénom(s) du souscripteur' }]}
            >
              <Input
                defaultValue={formData?.prenom}
                value={formData.prenom}
                onChange={(e) => setFormData((prev) => ({ ...prev, prenom: e.target.value }))}
                placeholder="Prénoms"
              />
            </Form.Item>
          </div>
        )}

        <div className="col-md-6">
          <Form.Item label="Adresse mail" name="email">
            <Input
              type="email"
              defaultValue={formData?.email}
              value={formData.email}
              onChange={(e) => setFormData((prev) => ({ ...prev, email: e.target.value }))}
              placeholder="Adresse mail"
            />
          </Form.Item>
        </div>

        <div className="col-md-6">
          <Form.Item
            label={formData.typePersonne === 'PHYSIQUE' ? 'Adresse de résidence' : 'Siège social'}
            name="adresse"
            rules={[{ required: true, message: "Veuillez renseigner l'adresse" }]}
          >
            <Input
              defaultValue={formData?.adresse}
              value={formData.adresse}
              onChange={(e) => setFormData((prev) => ({ ...prev, adresse: e.target.value }))}
              placeholder={formData.typePersonne === 'PHYSIQUE' ? 'Adresse de résidence' : 'Siège social'}
            />
          </Form.Item>
        </div>

        {formData.typePersonne === 'PHYSIQUE' && (
          <div className="col-md-6">
            <Form.Item
              label="Sexe"
              name="genre"
              initialValue={formData?.genre}
              rules={[{ required: true, message: 'Veuillez sélectionner le sexe' }]}
            >
              <Select
                defaultValue={formData.genre}
                value={formData.genre}
                onChange={(value) => setFormData((prev) => ({ ...prev, genre: value }))}
              >
                <Option value="MASCULIN">Masculin</Option>
                <Option value="FEMININ">Féminin</Option>
              </Select>
            </Form.Item>
          </div>
        )}

        {formData.typePersonne === 'PHYSIQUE' && (
          <>
            <div className="col-md-6">
              <Form.Item label="Profession" name="profession">
                <Select
                  showSearch
                  className="w-100"
                  defaultValue={formData.profession}
                  value={formData.profession}
                  onChange={(value) => setFormData((prev) => ({ ...prev, profession: value }))}
                  options={professions.map((p) => ({
                    label: p.libelleParametre,
                    value: p.libelleParametre,
                  }))}
                  placeholder="Sélectionnez la profession"
                  allowClear
                />
              </Form.Item>
            </div>

            <div className="col-md-6">
              <Form.Item label="Type de pièce" name="typePiece">
                <Select
                  defaultValue={formData?.typePiece}
                  value={formData.typePiece}
                  onChange={(value) => setFormData((prev) => ({ ...prev, typePiece: value }))}
                  allowClear
                >
                  <Option value={null}>Aucune</Option>
                  <Option value="CNI">CNI</Option>
                  <Option value="PASSEPORT">Passeport</Option>
                  <Option value="PERMIS">PERMIS DE CONDUIRE</Option>
                  <Option value="ELECTEUR">CARTE D'ELECTEUR</Option>
                </Select>
              </Form.Item>
            </div>

            <div className="col-md-6">
              <Form.Item label="Numéro de pièce" name="numIdentite">
                <Input
                  defaultValue={formData?.numIdentite}
                  value={formData.numIdentite}
                  onChange={(e) => setFormData((prev) => ({ ...prev, numIdentite: e.target.value }))}
                  placeholder="Numéro de la pièce"
                />
              </Form.Item>
            </div>

            <div className="col-md-6">
              <Form.Item label="Lieu de délivrance" name="lieuDelivrance">
                <Input
                  defaultValue={formData?.lieuDelivrance}
                  value={formData.lieuDelivrance}
                  onChange={(e) => setFormData((prev) => ({ ...prev, lieuDelivrance: e.target.value }))}
                  placeholder="Lieu de délivrance"
                />
              </Form.Item>
            </div>

            <div className="col-md-6">
              <Form.Item label="Date de délivrance" name="dateDelivrance">
                <Input
                  type="date"
                  defaultValue={formData?.dateDelivrance}
                  value={formData.dateDelivrance}
                  onChange={(e) => setFormData((prev) => ({ ...prev, dateDelivrance: e.target.value }))}
                />
              </Form.Item>
            </div>

            <div className="col-md-6">
              <Form.Item label="Date de naissance" name="dateNaissance">
                <Input
                  type="date"
                  defaultValue={formData?.dateNaissance}
                  value={formData.dateNaissance}
                  onChange={(e) => setFormData((prev) => ({ ...prev, dateNaissance: e.target.value }))}
                />
              </Form.Item>
            </div>
          </>
        )}

        {formData.typePersonne === 'MORALE' && (
          <>
            <div className="col-md-6">
              <Form.Item label="Numéro de registre de commerce" name="numeroRegistreCommerce">
                <Input
                  defaultValue={formData?.numeroRegistreCommerce}
                  value={formData.numeroRegistreCommerce}
                  onChange={(e) =>
                    setFormData((prev) => ({ ...prev, numeroRegistreCommerce: e.target.value }))
                  }
                  placeholder="Numéro de registre de commerce"
                />
              </Form.Item>
            </div>

            <div className="col-md-6">
              <Form.Item label="Numéro d'identification fiscale" name="nif">
                <Input
                  defaultValue={formData?.nif}
                  value={formData.nif}
                  onChange={(e) => setFormData((prev) => ({ ...prev, nif: e.target.value }))}
                  placeholder="NIF"
                />
              </Form.Item>
            </div>
          </>
        )}

        <div className="col-md-6">
          <Form.Item
            label="Numéro de téléphone"
            name="telephone"
            rules={[
              { required: true, message: 'Veuillez entrer le numéro de téléphone' },
              {
                validator: (_, value) => {
                  if (!value) return Promise.resolve()
                  const digits = sanitizePhone(value)
                  console.log(digits);
                  if (!phoneRegex.test(digits)) {
                    return Promise.reject(new Error('Numéro de téléphone invalide'))
                  }
                  return Promise.resolve()
                },
              },
            ]}
          >
            <Input.Group compact>
              <Input
                style={{ width: '40%' }}
                value="TG (+228)"
                disabled
              />
              <input
                className="ant-input"
                style={{ width: '60%' }}
                type="text"
                inputMode="numeric"
                placeholder="90 00 00 00"
                maxLength={11}
                defaultValue={formatPhoneDisplay(formData?.contact?.[0] || '')}
                onKeyDown={(e) => {
                  if (e.key === ' ') e.preventDefault()
                }}
                onPaste={(e) => {
                  e.preventDefault()
                  const text = e.clipboardData.getData('text') || ''
                  const digits = sanitizePhone(text)
                  e.currentTarget.value = formatPhoneDisplay(digits)
                  setFormData((prev) => ({ ...prev, contact: [digits] }))
                }}
                onChange={handlePhoneChange}
              />
            </Input.Group>
          </Form.Item>
        </div>
      </div>
    </div>
  )
}

export default SouscripteurForm
